import * as React from 'react';
import * as styles from './SeoSubtitles.css';
import { Text } from '../Text';

interface ISeoSubtitlesProps {
  subtitles: string[];
}
export const SeoSubtitles: React.FC<ISeoSubtitlesProps> = ({ subtitles }) => {
  return (
    <ul className={styles['list']}>
      {subtitles.map(item => (
        <li key={item} className={styles['item']}>
          <Text fontSize={14} fontWeight="normal" lineHeight={20} tagName="span" color="gray_4">
            {item}
          </Text>
        </li>
      ))}
    </ul>
  );
};
